import { AmlLimitsRepository } from '@core/repositories/aml-limits.repository';
import { AmlLimit } from '@shared/interfaces/aml-limit';
import { Observable, of, throwError } from 'rxjs';

interface ResultAmlLimits {
  id: number;
  attributes: {
    monthlyCount: number;
    monthlyValue: number;
    annualCount: number;
    annualValue: number;
  };
  relationships: {
    segment: {
      id: string;
      name: string;
    };
  };
}

interface ResultSegment {
  id: string;
  attributes: {
    name: string;
  };
}

export class FakeAmlLimitsRepository implements AmlLimitsRepository {
  dataAmlLimits: Array<ResultAmlLimits> = [
    {
      id: 1,
      attributes: {
        monthlyCount: 2,
        monthlyValue: 20000,
        annualCount: 20,
        annualValue: 40000
      },
      relationships: {
        segment: {
          id: '101',
          name: 'S1'
        }
      }
    },
    {
      id: 2,
      attributes: {
        monthlyCount: 4,
        monthlyValue: 50000,
        annualCount: 60,
        annualValue: 80000
      },
      relationships: {
        segment: {
          id: '201',
          name: 'S2'
        }
      }
    }
  ];

  dataSegments: Array<ResultSegment> = [
    {
      id: '101',
      attributes: {
        name: 'S1'
      }
    },
    {
      id: '201',
      attributes: {
        name: 'S2'
      }
    },
    {
      id: '301',
      attributes: {
        name: 'S3'
      }
    },
    {
      id: '401',
      attributes: {
        name: 'S4'
      }
    },
    {
      id: '501',
      attributes: {
        name: 'S5'
      }
    }
  ];

  amlLimits = {
    data: this.dataAmlLimits
  };

  segments = {
    data: this.dataSegments
  };

  getItems(): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.amlLimits);
  }

  add(limit: AmlLimit): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  edit(limit: AmlLimit): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  delete(item: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  segmentWithoutAmlLimits(): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.segments);
  }
}
